import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import analytics from './config/tools';

// Initialize analytics
analytics.initialize().catch((error) => {
  console.error('Error initializing analytics:', error);
});

// Make the analytics instance available globally for backward compatibility
window.isAnalyticsInitialized = analytics.isReady();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
